/**
 * CasaRosa product card + carousel runtime
 * - AJAX add-to-cart via /cart/add.js, publishes Dawn's cart-update pubsub event
 * - Interactive swatch click handler: updates variant id, image, and price
 * - Arrow navigation for carousel rails, hides arrows at scroll boundaries
 */
(function () {
  if (window.__casarosaCardInit) return;
  window.__casarosaCardInit = true;

  /* -------- Add to cart -------- */

  async function handleAddToCart(form) {
    var btn = form.querySelector('[data-cr-add-btn]');
    if (!btn || btn.classList.contains('is-loading')) return;

    btn.classList.remove('is-done', 'is-error');
    btn.classList.add('is-loading');
    btn.disabled = true;

    var formData = new FormData(form);
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url + '.js' : '/cart/add.js';

    try {
      var res = await fetch(addUrl, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!res.ok) {
        var errBody = await res.json().catch(function () { return null; });
        throw new Error(errBody && errBody.description ? errBody.description : 'Add to cart failed (' + res.status + ')');
      }

      var item = await res.json();

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'casarosa-product-card',
          productVariantId: item.variant_id,
          cartData: item
        });
      }

      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        if (typeof drawer.open === 'function') {
          drawer.open(btn);
        } else if (drawer.classList) {
          drawer.classList.add('active', 'animate', 'is-open');
          drawer.removeAttribute('inert');
        }
      }

      btn.classList.remove('is-loading');
      btn.classList.add('is-done');
      window.setTimeout(function () {
        btn.classList.remove('is-done');
        btn.disabled = false;
      }, 1500);

    } catch (err) {
      btn.classList.remove('is-loading');
      btn.classList.add('is-error');
      btn.disabled = false;
      console.error('[casarosa-card] add to cart failed:', err);
      window.setTimeout(function () {
        btn.classList.remove('is-error');
      }, 2000);
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('[data-cr-add-form]');
    if (!form) return;
    e.preventDefault();
    handleAddToCart(form);
  });

  /* -------- Swatch click: variant switching -------- */

  function handleSwatchClick(swatch) {
    var card = swatch.closest('[data-cr-card]');
    if (!card) return;

    var variantId = swatch.dataset.variantId;
    var variantPrice = swatch.dataset.variantPrice;
    var variantComparePrice = swatch.dataset.variantComparePrice || '';
    var variantImage = swatch.dataset.variantImage || '';
    var variantAvailable = swatch.dataset.variantAvailable === 'true';

    // 1. Update hidden form input (so add-to-cart sends the right variant)
    var input = card.querySelector('[data-cr-variant-input]');
    if (input && variantId) input.value = variantId;

    // 2. Update displayed product image (only if variant has its own image)
    if (variantImage) {
      var img = card.querySelector('.cr-prod-card__img');
      if (img && img.tagName === 'IMG') {
        img.removeAttribute('srcset');
        img.src = variantImage;
      }
    }

    // 3. Update price
    if (variantPrice) {
      var priceEl = card.querySelector('[data-cr-price]');
      if (priceEl) priceEl.textContent = variantPrice;
    }
    var wasEl = card.querySelector('[data-cr-price-was]');
    if (wasEl) {
      if (variantComparePrice) {
        wasEl.textContent = variantComparePrice;
        wasEl.hidden = false;
      } else {
        wasEl.textContent = '';
        wasEl.hidden = true;
      }
    }

    // 4. Update active state on all swatches in this card
    var siblings = card.querySelectorAll('[data-cr-swatch]');
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].classList.remove('is-active');
      siblings[i].setAttribute('aria-pressed', 'false');
    }
    swatch.classList.add('is-active');
    swatch.setAttribute('aria-pressed', 'true');

    // 5. Update ATC availability
    var atc = card.querySelector('.cr-prod-card__atc');
    if (atc) {
      if (variantAvailable) {
        atc.disabled = false;
        atc.classList.remove('cr-prod-card__atc--soldout');
      } else {
        atc.disabled = true;
        atc.classList.add('cr-prod-card__atc--soldout');
      }
    }
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target && e.target.closest && e.target.closest('[data-cr-swatch]');
    if (!swatch) return;
    e.preventDefault();
    handleSwatchClick(swatch);
  });

  /* -------- Carousel arrows -------- */

  function initCarousel(root) {
    if (root.__crInit) return;
    root.__crInit = true;

    var rail = root.querySelector('[data-cr-rail]');
    if (!rail) return;

    var arrowPrev = root.querySelector('[data-cr-arrow="prev"]');
    var arrowNext = root.querySelector('[data-cr-arrow="next"]');

    function scrollByPage(direction) {
      var item = rail.querySelector('.cr-carousel__item');
      if (!item) return;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 12;
      var step = item.offsetWidth + gap;
      rail.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    function updateArrows() {
      if (!arrowPrev || !arrowNext) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var pos = Math.abs(rail.scrollLeft);
      var atStart = pos < 2;
      var atEnd = (max - pos) < 2;
      arrowPrev.hidden = atStart;
      arrowNext.hidden = atEnd;
    }

    if (arrowPrev) {
      arrowPrev.addEventListener('click', function () { scrollByPage(-1); });
    }
    if (arrowNext) {
      arrowNext.addEventListener('click', function () { scrollByPage(1); });
    }

    rail.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    window.setTimeout(updateArrows, 60);
  }

  function initAll() {
    var carousels = document.querySelectorAll('[data-cr-carousel]');
    Array.prototype.forEach.call(carousels, initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
